import { v4 as uuidv4 } from 'uuid';


const Plantbased = [{
    "name": "Kashmiri Chickpea Bowls",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Coconut Spinach Tempeh",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Tofu Saag Panner",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Mung Bean Kitchari",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Mediterranean Veggie Sandwich",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Teriyaki Vegetable",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Mediterranean Couscous Bowls",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  },
  {
    "name": "Cauliflower Tacos",
    "price": [150, 290],
    "isVeg": true,
    "rating": 4.5,
    "type": "Plant Based",
    "id":uuidv4()
  }
]

export default Plantbased;